module.exports = __webpack_public_path__ + "img/videoOutput.46299472.gif";